import React from 'react';
import { WarningCircleIcon } from '@fronton/icons-react';
import { Divider, Section, Typography } from 'common/components';
import { lowerBoundsBreakpoints } from 'common/styles/breakpoints';
import { createElementKey } from 'utils';
import { KITCHEN_PRICE_PDP_CDN_PATH } from '../../kitchen-price-pdp-constants';
import { COLLECTION_COMPOSITION_LIST } from './collection-composition-constants';
import {
  collectionComposition,
  collectionCompositionContent,
  collectionCompositionHeader,
  collectionCompositionHeaderIcon,
  collectionCompositionHeaderText,
  collectionCompositionImage,
  collectionCompositionName,
  collectionCompositionText,
  collectionCompositionTextRow,
  collectionCompositionTextWrapper,
} from './collection-composition-styles';

export const CollectionComposition = () => (
  <Section className={collectionComposition}>
    <div className={collectionCompositionHeader}>
      <WarningCircleIcon
        className={collectionCompositionHeaderIcon}
        type="fill"
        size="xxl"
        color="attention-primary"
      />
      <div className={collectionCompositionHeaderText}>
        <Typography size="subtitle" variant="l">
          Цена указана за&nbsp;стандартную комплектацию 240&nbsp;см
        </Typography>
        <Typography size="body_short" variant="m">
          В&nbsp;стоимость не&nbsp;входят: столешница, стеновая панель, мойка, смеситель, дверные ручки,
          а&nbsp;также фурнитура для крепления шкафов на&nbsp;стену.
        </Typography>
      </div>
    </div>
    <div className={collectionCompositionContent}>
      <picture>
        <source
          srcSet={`${KITCHEN_PRICE_PDP_CDN_PATH}/collection-composition/size-chart-ld.jpg/size-chart-ld.jpg`}
          media={lowerBoundsBreakpoints['--from-large-desktop']}
        />
        <source
          srcSet={`${KITCHEN_PRICE_PDP_CDN_PATH}/collection-composition/size-chart-d.jpg/size-chart-d.jpg`}
          media={lowerBoundsBreakpoints['--from-desktop']}
        />
        <source
          srcSet={`${KITCHEN_PRICE_PDP_CDN_PATH}/collection-composition/size-chart-t.jpg/size-chart-t.jpg`}
          media={lowerBoundsBreakpoints['--from-tablet']}
        />
        <img
          alt="Изображение размеров кухни"
          className={collectionCompositionImage}
          src={`${KITCHEN_PRICE_PDP_CDN_PATH}/collection-composition/size-chart-m.jpg/size-chart-m.jpg`}
        />
      </picture>

      <div className={collectionCompositionTextWrapper}>
        {COLLECTION_COMPOSITION_LIST.map(({ name, quantity }, index: number) => (
          <div
            className={collectionCompositionTextRow}
            key={createElementKey('collection-composition', index)}>
            <div className={collectionCompositionText}>
              <Typography className={collectionCompositionName} variant="m" size="body_accent">
                {name}
              </Typography>
              <Typography variant="m" size="body_long">
                {quantity}
              </Typography>
            </div>
            <Divider />
          </div>
        ))}
      </div>
    </div>
  </Section>
);
